import React, { Dispatch, SetStateAction } from 'react';
import classNames from 'classnames';
import { ColorResult, HsvaColor } from '@uiw/color-convert';
import Wheel from '@uiw/react-color-wheel';
import './index.scss';

type ColorPickerProps = {
  hsva: HsvaColor;
  setHsva: Dispatch<SetStateAction<HsvaColor>>;
  handlePointerUp: () => void;
  isOn?: boolean;
  setPreventSwipeViews?: Dispatch<SetStateAction<boolean>>;
};

export const ColorPicker: React.FC<ColorPickerProps> = ({
  hsva,
  setHsva,
  handlePointerUp,
  isOn,
  setPreventSwipeViews,
}) => {
  const handleTouchMove = () => setPreventSwipeViews?.(true);

  const handleChange = (color: ColorResult) => setHsva({ ...hsva, ...color.hsva });

  return (
    <div className="color-picker-container">
      <div className={classNames('color-picker-background', { 'turn-on': isOn })}>
        <Wheel
          color={hsva}
          width={244}
          height={244}
          onChange={handleChange}
          onTouchMove={handleTouchMove}
          onPointerUp={handlePointerUp}
        />
      </div>
    </div>
  );
};
